module.exports = __webpack_public_path__ + "static/img/1805_9.6618ee5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1805_9.jpg
// module id = g7Bm
// module chunks = 1